// PFI Contact Settings Management
import { db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';

// Default contact information
const defaultContactInfo = {
  companyName: 'Pink Flamingo Interiors',
  primaryContact: 'Pink Flamingo Team',
  phone: '+61 400 000 000',
  email: 'info@pinkflamingo.com.au',
  address: '',
  website: 'https://www.pinkflamingo.com.au',
  projectsEmail: 'projects@pinkflamingo.com.au',
  suppliersEmail: 'suppliers@pinkflamingo.com.au',
  adminPhone: '+61 400 000 000'
};

// Get PFI contact information from Firestore or return defaults
export const getPFIContactInfo = async () => {
  try {
    const contactRef = doc(db, 'settings', 'pfiContact');
    const contactDoc = await getDoc(contactRef);
    
    if (contactDoc.exists()) {
      const data = contactDoc.data();
      // Merge with defaults to ensure all fields are present
      return { ...defaultContactInfo, ...data };
    }
    
    // If no contact info exists in Firestore, return defaults
    return defaultContactInfo;
  } catch (error) {
    console.error('Error getting PFI contact info:', error);
    return defaultContactInfo;
  }
};

// Format contact info for email footers
export const formatEmailFooter = (contactInfo) => {
  const contact = contactInfo || defaultContactInfo;
  
  return {
    companyName: contact.companyName,
    contactEmail: contact.projectsEmail || contact.email,
    supportEmail: contact.suppliersEmail || contact.email,
    phone: contact.phone,
    address: contact.address,
    website: contact.website
  };
};

// Get admin notification settings
export const getAdminNotificationSettings = (contactInfo) => {
  const contact = contactInfo || defaultContactInfo;
  
  return {
    adminPhone: contact.adminPhone || contact.phone,
    notificationEmail: contact.projectsEmail || contact.email
  };
};